"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Input } from "@components/ui/input";
import { Label } from "@components/ui/label";
export interface AdminDestroyConfirmationProps {
  readonly expectedValue: string;
  readonly value: string;
  readonly disabled: boolean;
  readonly onChange: (value: string) => void;
}
export const isAdminDestroyConfirmationValid = (expectedValue: string, value: string): boolean => value === expectedValue;
export const AdminDestroyConfirmation = t0 => {
  const $ = _c(26);
  const {
    expectedValue,
    value,
    disabled,
    onChange
  } = t0;
  const t = useTranslations("features.personal-access-tokens.ui.adminDestroyConfirmation");
  let t1;
  if ($[0] !== t) {
    t1 = t("warning");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="text-sm text-destructive">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("label");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== expectedValue) {
    t4 = <code className="font-mono">{expectedValue}</code>;
    $[6] = expectedValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Label htmlFor="admin-pat-destroy-confirmation">{t3} {t4}</Label>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("label");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onChange) {
    t7 = event => onChange(event.target.value);
    $[13] = onChange;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== disabled || $[16] !== t6 || $[17] !== t7 || $[18] !== value) {
    t8 = <Input id="admin-pat-destroy-confirmation" aria-label={t6} autoComplete="off" disabled={disabled} value={value} onChange={t7} />;
    $[15] = disabled;
    $[16] = t6;
    $[17] = t7;
    $[18] = value;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t8) {
    t9 = <div className="grid gap-2">{t5}{t8}</div>;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t2 || $[24] !== t9) {
    t10 = <div className="space-y-3 rounded-md border border-destructive/30 bg-destructive/5 p-3">{t2}{t9}</div>;
    $[23] = t2;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};